<div class="page-container gap-24 font-color-black">
  <div class="page-title">Impressum</div>
  <span class="title-level-2">Angaben gemäß § 5 TMG</span>
  <div class="flex-c gap-8">
    <span class="title-level-2">
      Institut Wissen gemeinnützige UG (haftungsbeschränkt)
    </span>
    <span class="font-regular-body-large">
      vertreten durch: Sabrina Heizmann, Vanessa Diel
      <br />
      Kreuzstraße 7
      <br />
      77716 Hofstetten
    </span>
    <span class="font-regular-body-large">
      Handelsregister: HRB 735411 <br />
      Amtsgericht Freiburg
    </span>
  </div>
  <div class="flex-c gap-8">
    <span class="title-level-2"> Kontakt: </span>
    <span class="font-regular-body-large">
      E-Mail: kontakt(at)wissen.institute
      <br />
      Website: www.wissen.institute
      <br />
      Telefon: +49 6438 92 79 079
    </span>
  </div>

  <div class="flex-c gap-8">
    <span class="title-level-2">
      Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
    </span>
    <span class="font-regular-body-large"> Vanessa Diel </span>
  </div>

  <div class="flex-c gap-8">
    <a routerLink="/agb" target="_blank">Allgemeine Geschäftsbedingungen</a>
  </div>
</div>
